import React, { PureComponent } from 'react';

import { getUserFriendlyCron } from '../utils/recurring';

import TaskGroupName from './task-group-name';

export default class ResourceRepeatText extends PureComponent {
    render() {
        if (this.props.type === 'status') {
            return (
                <React.Fragment>
                    When in <TaskGroupName id={this.props.trigger} />
                </React.Fragment>
            )
        }

        if (this.props.type === 'completion') {
            return (
                <React.Fragment>
                    When marked completed
                </React.Fragment>
            )
        }

        if (this.props.cron) {
            return getUserFriendlyCron(this.props.cron);
        }

        return null;
    }
}
